import React, { FC, useContext } from 'react';

import { Tabs } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { EAdvertisementStatus } from 'types';

import { useMinLoadingTime } from '../useMinLoadingTime';
import { MyAdvertisementItem, MyAdvertisementSkeleton } from './components';
import {
  EAdvertisementActiveStatus,
  IMyAdvertisementProps,
} from './interfaces';
import s from './MyAdvertisement.module.scss';

export const MyAdvertisement: FC<IMyAdvertisementProps> = ({
  data,
  loading,
  status,
  setStatus,
  setAdvertisementManagerState,
  setAdvertisementViewState,
  advertisementStatus,
  setAdvertisementStatus,
}) => {
  const { t } = useContext(LocalizationContext);

  const ADVERTISEMENT_STATUS_OPTIONS = [
    {
      title: t('booking.list.tabs.active'),
      value: EAdvertisementActiveStatus.ACTIVE,
    },
    {
      title: t('non.active'),
      value: EAdvertisementActiveStatus.NON_ACTIVE,
    },
  ];
  const showSkeletons = useMinLoadingTime(loading, 350);
  return (
    <div className={s.container}>
      <Tabs
        options={ADVERTISEMENT_STATUS_OPTIONS}
        onChange={(value) => {
          setAdvertisementStatus(value);
          if (value === EAdvertisementActiveStatus.ACTIVE) {
            setStatus((prev) =>
              prev.map((status) => ({
                ...status,
                active: status.value === EAdvertisementStatus.ACTIVE,
              }))
            );
          } else {
            setStatus((prev) =>
              prev.map((status) =>
                status.value === EAdvertisementStatus.ACTIVE
                  ? { ...status, active: false }
                  : status
              )
            );
          }
        }}
        value={advertisementStatus}
        className={s.tabs}
      />

      {advertisementStatus === EAdvertisementActiveStatus.NON_ACTIVE && (
        <div className={s.cheeps}>
          {status
            .filter((item) => item.value !== EAdvertisementStatus.ACTIVE)
            .map((item) => (
              <div
                onClick={() => {
                  setStatus((prev) =>
                    prev.map((status) =>
                      status.value === item.value
                        ? { ...status, active: !status.active }
                        : status
                    )
                  );
                }}
                key={item.value}
                className={cn(s.item, item.active && s.active)}
              >
                <span className={s.check_text}>{item.title}</span>
              </div>
            ))}
        </div>
      )}
      <div className={s.main}>
        {showSkeletons
          ? [1, 2, 3, 4, 5].map((item) => (
              <MyAdvertisementSkeleton key={item} />
            ))
          : data?.map((item) => (
              <MyAdvertisementItem
                key={item.id}
                data={item}
                setAdvertisementManagerState={setAdvertisementManagerState}
                setAdvertisementViewState={setAdvertisementViewState}
              />
            ))}
      </div>
    </div>
  );
};
